'use client';
import React from 'react';
import cn from '@utils/cn';
import { GridColFullWidth } from '@constants/layout';
import useIsMobile from '@lib/hooks/useIsMobile';
import Pagination from './Pagination';
import { StaticIcon } from '@ui/Icon/StaticIcon/StaticIcon';
import IconType from '@ui/Icon/StaticIcon/IconType';

type Props = {
  onClick: (num: number) => void;
  totalCount?: number;
  selectedPageNum: number;
};

export default function NavBar({ totalCount, onClick, selectedPageNum }: Props) {
  const isMobile = useIsMobile();
  const totalNumOfPages = Math.ceil((totalCount ?? 0) / 20);

  if (!totalCount || totalCount <= 20) {
    return;
  }

  return (
    <div className={cn(GridColFullWidth, 'flex items-center justify-center gap-1.5 py-4')}>
      <StaticIcon
        icon={IconType.chevronLeft}
        className={cn('fill-body-foreground flex h-8 w-8 justify-center', {
          'opacity-40': selectedPageNum <= 1,
          'hover:bg-input cursor-pointer rounded': selectedPageNum > 1,
        })}
        onClick={() => selectedPageNum > 1 && onClick(selectedPageNum - 1)}
      />
      <Pagination
        currentPage={selectedPageNum}
        totalPages={totalNumOfPages}
        onPageChange={onClick}
        isMobile={isMobile}
      />
      <StaticIcon
        icon={IconType.chevronRight}
        className={cn('fill-body-foreground flex h-8 w-8 justify-center', {
          'opacity-40': selectedPageNum >= totalNumOfPages,
          'hover:bg-input cursor-pointer rounded': selectedPageNum < totalNumOfPages,
        })}
        onClick={() => selectedPageNum < totalNumOfPages && onClick(selectedPageNum + 1)}
      />
    </div>
  );
}
